'use strict';

// mark export object to esm
Object.defineProperty(exports, '__esModule', {
  value: true
});
var warn = function warn(s) {};
exports.default = warn;